export class EwayVehiclListDetail {
    public update_mode!: string;
    public vehicle_number!: string;
    public place_of_consignor!: string;
    public state_of_consignor!: string;
    public tripshtNo!: number;
    public userGstin!: string;
    public vehicle_number_update_date!: string;
    public transportation_mode!: string;
    public transporter_document_number!: string;
    public transporter_document_date!: string;
    public group_number!: string;
}